/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { Field } from 'redux-form';
import classNames from 'classnames';

// Components
import { IntegerInput, MoneyInput } from 'components/forms/form-elements';


export default function LineItemRows({ fields, lineItems, lineItemNote }) {
  return (
    <tbody>
      {fields.map((name, index) =>
        <LineItemRow
          key={index}
          name={name}
          lineItem={lineItems[index]}
          lineItemNote={lineItemNote}
        />
      )}
    </tbody>
  );
}


// Internal component
export function LineItemRow({ name, lineItem, index, lineItemNote }) {
  const lineItemQuantity = Number(lineItem.quantity);
  const total = (lineItem.quantity * lineItem.unitCost) || 0;

  return (
    <tr className={classNames('line-item-row', { deemphasize: lineItemQuantity <= 0 || !lineItemQuantity })}>
      <td />
      <td>
        <Field component={IntegerInput} name={`${name}.quantity`} addonLeft="Qty" autoFocus={index === 0} />
      </td>
      <td>
        { lineItemQuantity > 0 &&
          <Field component={MoneyInput} name={`${name}.unitCost`} />
        }
      </td>
      <td className="right-align">
        { lineItemQuantity > 0 &&
          numeral(total).format('$0,0.00')
        }
      </td>
      <td className="large-padding-left">
        {lineItem.description} <span className="deemphasize">{lineItemNote}</span>
      </td>
    </tr>
  );
}



// WEBPACK FOOTER //
// ./app/components/models/purchases/forms/components/expense-bill-line-item-rows.js